import { inject, Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { catchError, Observable } from "rxjs";
import { IPLUS_URL, NODEJS_URL } from "@app/shared/constants/url.constants";
import { NotifyService } from "@app/core/services/notify.service";
import { AppInjector } from "@app/core/functions/app-injector";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { Router } from "@angular/router";
import { ROUTES } from "@app/shared/constants/routes.constants";

/**
 * Adds a default error handler to all requests.
 */
@Injectable({
  providedIn: "root"
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private router = inject(Router);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((error) => this._errorHandler(error)));
  }

  /**
   * Handle any errors and display any notifications returned from server
   * @param response
   */
  private _errorHandler(response: HttpEvent<any>): Observable<HttpEvent<any>> {
    if (response instanceof HttpErrorResponse) {
      this._handleAuthenticationError(response);

      try {
        if (response.error.notifications.length > 0) {
          this.notifyService.popNotifications(response.error.notifications);
        }
      } catch {}
    }

    throw response;
  }
  /**
   * Handle unauthorized tokens and logins
   * Ignore 401 error when user is authenticating an account.
   * @param response p
   */
  private _handleAuthenticationError(response: HttpErrorResponse) {
    switch (response?.status === 401) {
      case response.message.includes(IPLUS_URL.AUTHENTICATE_USER):
      case response.message.includes(IPLUS_URL.AUTHENTICATE_PASS):
      case response.message.includes(NODEJS_URL.GET_TOKEN): {
        break;
      }
      default: {
        this.authService.token = null;
        this.router.navigate([ROUTES.LOGIN]);
      }
    }
  }

  /**
   * Inject notification service at runtime
   */
  private get notifyService(): NotifyService {
    return AppInjector.get(NotifyService);
  }

  private get authService(): AuthenticationService {
    return AppInjector.get(AuthenticationService);
  }
}
